import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import RouteMap from './RouteMap';
import NotFound from '../pages/NotFound';
import Home from '../pages/Home';
import Notifications from '../components/common/Notifications';
import LiveAuctions from '../pages/LiveAuctions';
import LiveAuction from '../pages/LiveAuctions/LiveAuction';
import Explore from '../pages/Explore';
import Create from '../pages/Create';
import ConnectWallet from '../pages/ConnectWallet';
import ClaimingNFT from '../pages/ClaimingNFT';
import ClaimingNFTSuccess from '../pages/ClaimingNFT/Success';
import Profile from '../pages/Profile/ViewProfile';
import UserProfile from '../pages/UserProfile';
import EditProfile from '../pages/Profile/EditProfile';
import Upvote from '../pages/Profile/Upvote';
import CommunityUpvote from '../pages/Profile/CommunityUpvote';
import VerifyProfile from '../pages/Profile/VerifyProfile';
import VerifyProfileViaTwitter from '../pages/Profile/VerifyProfile/ViaTwitter';
import Search from "../pages/Search";
import SingleNFT from "../pages/NFT";

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" render={() => <Redirect to={RouteMap.home} />} />
      <Route path={RouteMap.home} component={Home} />
      <Route path={RouteMap.notifications} component={Notifications} />
      <Route path={RouteMap.liveAuctions.view(':id')} component={LiveAuction} />
      <Route path={RouteMap.nft.view(':id')} component={SingleNFT} />
      <Route path={RouteMap.liveAuctions.index} component={LiveAuctions} />
      <Route path={RouteMap.explore} component={Explore} />
      <Route path={RouteMap.search()} component={Search} />
      <Route path={RouteMap.create} component={Create} />
      <Route path={RouteMap.connectWallet} component={ConnectWallet} />
      <Route path={RouteMap.claimingNFT.success} component={ClaimingNFTSuccess} />
      <Route path={RouteMap.claimingNFT.index} component={ClaimingNFT} />
      <Route path={RouteMap.user(':userId')} component={UserProfile}/>
      <Route path={RouteMap.profile.verifyProfile.viaTwitter} component={VerifyProfileViaTwitter} />
      <Route path={RouteMap.profile.verifyProfile.index} component={VerifyProfile} />
      <Route path={RouteMap.profile.upvote} component={Upvote} />
      <Route path={RouteMap.profile.communityUpvote} component={CommunityUpvote} />
      <Route path={RouteMap.profile.edit} component={EditProfile} />
      <Route path={RouteMap.profile.index} component={Profile} />
      <Route component={NotFound} />
    </Switch>
  );
};

export default Routes;
